<template>
    <div>
        <div class="alert alert-danger"
             v-if="error">
            {{ errorMessage }}
        </div>
        <form role="form">
            <div v-if="project"
                 class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Project</label>
                <div class="col-md-8">
                    <span class="form-static-input">{{ project.name }}</span></a>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Title</label>
                <div class="col-md-8">
                    <input v-model="form.title"
                           type="text"
                           class="form-control"
                           name="title"
                           :autofocus="!isEditing"
                           :class="{'is-invalid': form.errors.has('title')}" />
                        <span class="text-danger"
                          v-show="form.errors.has('title')">
                            {{ form.errors.get('title') }}
                        </span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Description</label>
                <div class="col-md-8">
                    <textarea v-model="form.description"
                              type="text"
                              rows="5"
                              class="form-control"
                              name="description"></textarea>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Material location</label>
                <div class="col-md-8">
                    <input v-model="form.material_location"
                           type="text"
                           class="form-control"
                           name="material_location" />
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Estimated dates</label>

                <div class="col-md-8">
                    <div class="row no-gutters">
                        <div class="col-md-5">

                            <div v-if="workOrder">
                                <date-picker-wrapper :date="dateFromString(workOrder.start_date)" :placeholder="'Start Date'" :onClear="clearStartDate" @selected-date="startDate = $event" :error="form.errors.has('startDate')" :not-before="null"></date-picker-wrapper>
                            </div>
                            <div v-else>
                                <date-picker-wrapper :date="null" :placeholder="'Start date'" :onClear="clearStartDate" @selected-date="startDate = $event" :error="form.errors.has('startDate')" :not-before="null"></date-picker-wrapper>
                            </div>

                            <span class="text-danger"
                              v-show="form.errors.has('startDate')">
                                {{ form.errors.get('startDate') }}
                            </span>
                        </div>
                        <div class="col-md-2 col-form-label text-center">
                            until
                        </div>
                        <div class="col-md-5">

                            <div v-if="workOrder">
                                <date-picker-wrapper :date="dateFromString(workOrder.end_date)" :placeholder="'End date'" :onClear="clearEndDate" :not-before="startDate" @selected-date="endDate = $event" :error="form.errors.has('endDate')"></date-picker-wrapper>
                            </div>
                            <div v-else>
                                <date-picker-wrapper :date="null" :placeholder="'End date'" :not-before="startDate" :onClear="clearEndDate" @selected-date="endDate = $event" :error="form.errors.has('endDate')"></date-picker-wrapper>
                            </div>

                            <span class="text-danger"
                              v-show="form.errors.has('endDate')">
                                {{ form.errors.get('endDate') }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Assign to</label>
                <div class="col-md-8">
                    <div class="work-order-crew-dropdown crew">
                        <div class="dropdown">
                            <input type="text"
                                   v-model="crewFilterInput"
                                   @input="crewFilterInputChanged"
                                   class="form-control dropdown-toggle crew text-left"
                                   :disabled="loadingCrew"
                                   @focus="crewFilterInputActive = true"
                                   @blur="crewFilterInputActive = false"
                                   id="dropdownMenuButton"
                                   name="crewFilterInput"
                                   :placeholder="crewInputPlaceholder"
                                   data-toggle="dropdown"
                                   aria-haspopup="true"
                                   aria-expanded="false"
                                   aria-label="crew-filter"
                                   aria-describedby="search-icon" />
                            <div class="dropdown-menu"
                                 aria-labelledby="dropdownMenuButton">
                                 <div v-if="loadingCrew"
                                      class="dropdown-item no-results">
                                     <span class="text-muted">Loading crew...</span>
                                 </div>
                                <div v-else-if="filteredCrew.length < 1"
                                     class="dropdown-item no-results">
                                    <span class="text-muted">No results</span>
                                </div>
                                <div v-for="crewMember in filteredCrew"
                                     class="dropdown-item crew-link"
                                     @mousedown="clickedCrewMember(crewMember)">
                                    {{ crewMember.name }}
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-valign-middle mb-0">
                                <tbody>
                                    <tr v-for="crewMember in selectedCrew"
                                        class="work-order-crew-list">
                                        <td class="name">
                                            <div class="btn-table-align">
                                                <div>{{ crewMember.name }}</div>
                                            </div>
                                        </td>
                                        <td class="email">
                                            <div class="btn-table-align">
                                                {{ crewMember.email }}
                                            </div>
                                        </td>
                                        <td class="button">
                                            <div class="btn-table-align">
                                                <div class="text-muted remove-button"
                                                     @click="clickedRemove(crewMember)">
                                                     Remove
                                               </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Depends on</label>
                <div class="col-md-8">
                    <div class="work-order-crew-dropdown workorders">
                        <div class="dropdown">
                            <input type="text"
                                   v-model="workOrderFilterInput"
                                   @input="workOrderFilterInputChanged"
                                   class="form-control dropdown-toggle workorders text-left"
                                   :disabled="loadingWorkOrders"
                                   @focus="workOrderFilterInputActive = true"
                                   @blur="workOrderFilterInputActive = false"
                                   id="dropdownMenuButton"
                                   name="workOrderFilterInput"
                                   :placeholder="workOrdersInputPlaceholder"
                                   data-toggle="dropdown"
                                   aria-haspopup="true"
                                   aria-expanded="false"
                                   aria-label="work-order-filter"
                                   aria-describedby="search-icon" />
                            <div class="dropdown-menu"
                                 aria-labelledby="dropdownMenuButton">
                                 <div v-if="loadingWorkOrders"
                                      class="dropdown-item no-results">
                                     <span class="text-muted">Loading work orders...</span>
                                 </div>
                                <div v-else-if="filteredWorkOrders.length < 1"
                                     class="dropdown-item no-results">
                                    <span class="text-muted">No results</span>
                                </div>
                                <div v-for="workOrder in filteredWorkOrders"
                                     class="dropdown-item crew-link"
                                     @mousedown="clickedWorkOrder(workOrder)">
                                    {{ workOrder.title }}
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-valign-middle mb-0">
                                <tbody>
                                    <tr v-for="workOrder in selectedWorkOrders"
                                        class="work-order-crew-list">
                                        <td class="name">
                                            <div class="btn-table-align">
                                                <div>{{ workOrder.title }}</div>
                                            </div>
                                        </td>
                                        <td class="button">
                                            <div class="btn-table-align">
                                                <div class="text-muted remove-button"
                                                     @click="clickedRemoveWorkOrder(workOrder)">
                                                     Remove
                                               </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Team notifications</label>
                <div class="col-md-2 my-auto">
                    <toggle-button :value="notifyTeam"
                                   @change="notifyTeamChanged"
                                   color="#000000"
                                   :sync="true"
                                   :width="75"
                                   :height="33"
                                   :labels="{checked: 'Yes', unchecked: 'No'}"
                                   :font-size="14"
                                   />
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Notify customer of status updates?</label>
                <div class="col-md-2 my-auto">
                    <toggle-button :value="notifyCustomer"
                                   @change="notifyCustomerChanged"
                                   color="#000000"
                                   :sync="true"
                                   :width="75"
                                   :height="33"
                                   :labels="{checked: 'Yes', unchecked: 'No'}"
                                   :font-size="14"
                                   />
                </div>
            </div>

            <transition name="fade">
                <div key="key1" v-if="notifyCustomer && customer">
                    <div class="form-group row">
                        <div class="col-md-8 offset-md-3">
                            <div class="alert alert-light">
                                <p class="font-weight-600"><i class="fas fa-envelope"></i> <span class="ml-1">Good to know!</span></p>
                                <div>Updating the status of this work order will send an email to <span class="font-weight-600">{{ customer.name }}</span> letting them know about the progress.</div>
                                <br />
                                <div>For example, <span class="text-primary font-weight-600">{{ sampleEmailText }}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <div class="form-group row">
                <div class="col-md-8 offset-md-3">
                    <div v-if="selectedCrew.length > 0"
                         class="new-change-order-note">
                        <hr />Once created or updated, {{ selectedCrew.length }} {{ pluralizeCrewMembers }} will be notified of the work order.
                    </div>
                </div>
            </div>
            <div class="form-group row mb-0">
                <div class="col-md-8 offset-md-3">
                    <button type="button"
                            class="btn btn-primary"
                            @click="submit"
                            :disabled="form.busy || loadingCrew || loadingWorkOrders ">{{ saveButtonTitle }}</button>
                    <button v-if="workorders && workorders.length > 0"
                            type="button"
                            class="btn btn-secondary ml-2"
                            @click="cancelForm">
                            Cancel
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
export default
{
    props: ['role', 'project', 'isEditing', 'workorders', 'workOrder'],
    created: function()
    {
        this.getCrew();
        this.getWorkOrders();
        this.getCustomer();
    },

    mounted: function() {

    },

    data: function()
    {
        return {
            form: new SparkForm(
            {
                title:             this.workOrder && this.workOrder.title ? this.workOrder.title : '',
                description:       this.workOrder && this.workOrder.description ? this.workOrder.description : '',
                material_location: this.workOrder && this.workOrder.material_location ? this.workOrder.material_location : '',
                cost:              this.workOrder && this.workOrder.cost ? this.workOrder.cost : 0,
                image:             this.workOrder && this.workOrder.image ? this.workOrder.image : '',
                notifyCustomer:    this.workOrder ? !!this.workOrder.notify_customer : false,
                notifyTeam:        this.workOrder ? !!this.workOrder.notify_team : true,
                startDate:         this.workOrder && this.workOrder.start_date ? this.workOrder.start_date : null,
                endDate:           this.workOrder && this.workOrder.end_date ? this.workOrder.end_date : null,
                tax: 0,
            }),

            error: false,
            errorMessage: '',
            loadingCrew: true,
            loadingWorkOrders: true,

            customer: null,
            crew: [],
            selectedCrew: [],
            filteredCrew: [],
            crewFilterInput: '',
            crewFilterInputActive: false,

            workOrders: [],
            selectedWorkOrders: [],
            filteredWorkOrders: [],
            workOrderFilterInput: '',
            workOrderFilterInputActive: false,

            startDate: null,
            endDate: null,

            notifyCustomer: this.workOrder ? !!this.workOrder.notify_customer : false,
            notifyTeam:     this.workOrder ? !!this.workOrder.notify_team : true
        };
    },

    watch:
    {
        project: function(newVal, oldVal) {
            this.getWorkOrders();
        },

        formTitle: function(newVal, oldVal) {
            this.form.errors.forget('title');
        },

        startDate: function(newVal, oldVal) {
            console.log('new start date:');
            console.log(newVal);
            this.form.startDate = newVal;
            this.form.errors.forget('startDate');
        },

        endDate: function(newVal, oldVal) {
            this.form.endDate = newVal;
            this.form.errors.forget('endDate');
        },

        notifyCustomer: function(newVal, oldVal) {
            this.form.notifyCustomer = newVal;
        },

        notifyTeam: function(newVal, oldVal) {
            this.form.notifyTeam = newVal;
        },

        crewFilterInputActive: function(newVal, oldVal) {
            if (newVal != oldVal) {
                if (newVal == true) {
                    $('.work-order-crew-dropdown.crew .dropdown-menu').addClass('show');
                }
                else {
                    $('.work-order-crew-dropdown.crew .dropdown-menu').removeClass('show');
                }
            }
        },

        workOrderFilterInputActive: function(newVal, oldVal) {
            if (newVal != oldVal) {
                if (newVal == true) {
                    $('.work-order-crew-dropdown.workorders .dropdown .dropdown-menu').addClass('show');
                }
                else {
                    $('.work-order-crew-dropdown.workorders .dropdown .dropdown-menu').removeClass('show');
                }
            }
        },
    },

    computed:
    {
        sampleEmailText: function() {
            let formTitle = this.formTitle.length > 0 ? this.formTitle : 'drywall';
            return "\"Good news! Jason Smith has started work on " + formTitle + " and it should take 7 days to complete.\"";
        },

        formTitle: function() {
            return this.form.title;
        },

        workOrdersInputPlaceholder: function() {
            if (this.loadingWorkOrders) {
                return 'Loading work orders...';
            }
            return 'Search work orders';
        },

        crewInputPlaceholder: function() {
            if (this.loadingCrew) {
                return 'Loading team members...';
            }
            return 'Search team members';
        },

        pluralizeCrewMembers: function() {
            if (this.selectedCrew.length == 1) {
                return "team member";
            }

            return "team members";
        },

        saveButtonTitle: function() {
            if (this.workOrder) {
                if (this.workOrder.crew) {
                    if (this.workOrder.crew.length == 1) {
                        return "Save & notify assigned team members";
                    }
                    else if (this.workOrder.crew.length > 0) {
                        return "Save & notify assigned team member";
                    }
                }
            }

            return "Save";
        },

    },

    methods:
    {
        clearStartDate: function() {
            this.form.startDate = null;
        },

        clearEndDate: function() {
            this.form.endDate = null;
        },

        dateFromString: function(dateString) {
            if (dateString) {
                return moment(dateString).toDate();
            }
            return null;
        },

        getCustomer: function() {
            if (!this.project) {
                return;
            }

            if (!this.project.customer_id_1) {
                this.customer = null;
                return;
            }

            axios.get(`/api/customer/${this.project.customer_id_1}`)
                .then(response => {
                    this.customer = response.data;
                })
                .catch(error => {
                    this.customer = null;
                });
        },

        notifyCustomerChanged: function(event) {
            this.notifyCustomer = event.value;
        },

        notifyTeamChanged: function (event) {
            this.notifyTeam = event.value;
        },

        cancelForm: function() {
            Bus.$emit('new-work-order-canceled');
        },

        clickedWorkOrder: function(workOrderThatWasClicked)
        {
            var newWorkOrders = [];

            let localWorkOrderCopy = _.find(this.workOrders, workOrder => workOrder.id === workOrderThatWasClicked.id);
            if (localWorkOrderCopy)
            {
                newWorkOrders = _.reject(this.workOrders, workOrder => workOrder.id === workOrderThatWasClicked.id);
                this.selectedWorkOrders.push(workOrderThatWasClicked);
                this.workOrders = newWorkOrders;
            }
            this.workOrderFilterInput = '';
            this.filteredWorkOrders = this.workOrders;
        },

        clickedRemoveWorkOrder: function(workOrderClicked)
        {
            var newSelectedWorkOrders = [];
            if (this.selectedWorkOrders.indexOf(workOrderClicked) != -1)
            {
                newSelectedWorkOrders = _.reject(this.selectedWorkOrders, workOrder => workOrder.id === workOrderClicked.id);
                this.workOrders.push(workOrderClicked);
                this.selectedWorkOrders = newSelectedWorkOrders;
            }
            this.workOrderFilterInput = '';
            this.filteredWorkOrders = this.workOrders;
        },

        clickedCrewMember: function(crewMemberThatWasClicked)
        {
            var newCrew = [];

            let localCrewCopy = _.find(this.crew, crewMember => crewMember.id == crewMemberThatWasClicked.id);
            if (localCrewCopy)
            {
                newCrew = _.reject(this.crew, crewMember => crewMember.id === crewMemberThatWasClicked.id);
                this.selectedCrew.push(crewMemberThatWasClicked);
                this.crew = newCrew;
            }
            this.crewFilterInput = '';
            this.filteredCrew = this.crew;
        },

        clickedRemove: function(crewMemberClicked)
        {
            var newSelectedCrew = [];
            if (this.selectedCrew.indexOf(crewMemberClicked) != -1)
            {
                newSelectedCrew = _.reject(this.selectedCrew, crewMember => crewMember.id === crewMemberClicked.id);
                this.crew.push(crewMemberClicked);
                this.selectedCrew = newSelectedCrew;
            }
            this.crewFilterInput = '';
            this.filteredCrew = this.crew;
        },

        getWorkOrders: function()
        {
            if (!this.project) {
                return;
            }

            axios.get(`/api/workorders/${this.project.id}`)
                .then(response =>
                {
                    this.loadingWorkOrders = false;

                    // If editing, remove "this" work order from the
                    // list of possible dependent work orders
                    if (this.isEditing) {
                        this.workOrders = _.reject(response.data, workOrder => workOrder.id == this.workOrder.id);
                    }
                    else {
                        this.workOrders = response.data;
                    }

                    this.filteredWorkOrders = this.workOrders;

                    //initialize the dropdown now that we have data
                    $('.dropdown-toggle workorders').dropdown();

                    // Populate if we're editing
                    _.forEach(this.workOrder.all_required_work_orders, requiredWorkOrder => {
                        this.clickedWorkOrder(requiredWorkOrder);
                    });
                })
                .catch(error =>
                {
                    this.loadingWorkOrders = false;
                });
        },

        getCrew: function()
        {
            axios.get(`/api/crew`)
                .then(response =>
                {
                    this.loadingCrew = false;
                    this.crew = response.data.crew;
                    this.filteredCrew = this.crew;

                    //initialize the dropdown now that we have data
                    $('.dropdown-toggle crew').dropdown();

                    // Populate if we're editing
                    _.forEach(this.workOrder.crew, crewMember => {
                        this.clickedCrewMember(crewMember);
                    });
                })
                .catch(error =>
                {
                    this.loadingCrew = false;
                });
        },

        submit: function()
        {
            this.error = false;
            this.form.project_id = this.project.id;
            this.form.selectedCrew = this.selectedCrew;

            let requiredWorkOrderIds = [];

            _.forEach(this.selectedWorkOrders, requiredWorkOrder => {
                requiredWorkOrderIds.push(requiredWorkOrder.id);
            });

            this.form.requiredWorkOrderIds = requiredWorkOrderIds;

            if (this.isEditing) {
                Spark.put(`/api/workorders/${this.workOrder.id}`, this.form)
                    .then(response =>
                    {
                        this.workOrderUpdated(response);
                    })
                    .catch(error =>
                    {
                        //this.error = true;
                        //this.errorMessage = error.errors;
                    });
            }
            else {
                Spark.post('/api/workorders', this.form)
                    .then(response =>
                    {
                        this.newWorkOrderCreated(response);
                    })
                    .catch(error =>
                    {
                        //this.error = true;
                        //this.errorMessage = error.error;
                    });
            }
        },

        newWorkOrderCreated: function(response) {
            Bus.$emit('new-work-order-created', response);
            Bus.$emit('refresh-current-project');
            /*mixpanel.track('Work Order Created', {
                title: response.title,
            });*/
        },

        workOrderUpdated: function(response) {
            Bus.$emit('work-order-updated', response);
            Bus.$emit('refresh-current-project');
            /*mixpanel.track('Work Order Updated', {
                title: response.title,
            });*/
        },

        workOrderFilterInputChanged: function()
        {
            // Cleared search?
            if (this.workOrderFilterInput.length < 1)
            {
                this.filteredWorkOrders = _.difference(this.workOrders, this.selectedWorkOrders);
                return;
            }

            var filteredWorkOrders = [];
            var regexQuery = new RegExp(this.workOrderFilterInput, 'i');

            //Filter locally through our users
            for (var i = 0; i < this.workOrders.length; i++)
            {
                var workOrder = this.workOrders[i];

                //Search for name
                var match = regexQuery.test(workOrder.title);
                if (match)
                {
                    filteredWorkOrders.push(workOrder);
                    continue;
                }
            }

            this.filteredWorkOrders = filteredWorkOrders;
        },

        crewFilterInputChanged: function()
        {
            // Cleared search?
            if (this.crewFilterInput.length < 1)
            {
                this.filteredCrew = _.difference(this.crew, this.selectedCrew);
                return;
            }

            var filteredCrew = [];
            var regexQuery = new RegExp(this.crewFilterInput, 'i');

            //Filter locally through our users
            for (var i = 0; i < this.crew.length; i++)
            {
                var crewMember = this.crew[i];

                //Search for name
                var match = regexQuery.test(crewMember.name);
                if (match)
                {
                    filteredCrew.push(crewMember);
                    continue;
                }
            }

            this.filteredCrew = filteredCrew;
        }
    }
}

</script>

